// Helper unico para crear la raiz Vue de cada bundle del front (B1-B8).
//
// Por que existe
// --------------
// Con Vue 2 cada entry hacia `new Vue({ el, data: { transPeralbaPro } })` y
// registraba globalmente `x-icons` con `Vue.component()`. En Vue 3 el registro
// global es por aplicacion (`app.component`), asi que cada entry tiene que
// construir su propia app; este helper concentra lo que TODAS comparten y evita
// que un bundle nuevo se olvide de alguna de las dos cosas.
//
// Que garantiza
// -------------
// 1. `transPeralbaPro` existe siempre en el `data` de la raiz. El layout emite
//    `window.transPeralbaPro` una sola vez por pagina y los Blade pasan
//    `:trans-peralba-pro="transPeralbaPro"` a los componentes montados: sin esa
//    clave en la raiz, el binding revienta (docs/frontend/translations-payload.md).
// 2. El componente de iconos queda registrado con la etiqueta que usa el Blade:
//    `x-icons` en todos los bundles menos la ficha de producto, que la llama
//    `vue-icon`.
// 3. Devuelve la app SIN montar: el entry sigue con `app.component(...)`,
//    `app.use(...)`, `app.filter(...)` y termina con `app.mount("#id")`.
//
// Excepcion: la ficha de producto (sections/front/product/index.js) NO usa este
// helper. Su raiz es ProductDetails.vue, que declara `transPeralbaPro` como
// prop, y el helper lo pondria ademas en el `data` de la raiz (Vue avisaria
// "Data property already defined in Props"); ese entry hace
// `createApp(ProductDetails, props)` y registra `vue-icon` el mismo.
//
// `rootOptions` se fusiona tal cual (watch, computed, filters, mounted... del
// header viajan por aqui); si trae su propio `data()` se respeta y se mezcla con
// `transPeralbaPro`, nunca se pisa.
import { createApp } from "vue"; // vue.esm-bundler.js, con compilador (webpack.mix.js)
import XIcons from "./sections/front/icons/XIcons.vue";

export function createPageApp(
  rootOptions = {},
  { iconsTag = "x-icons", rootData = {} } = {}
) {
  const { data: ownData, ...restOptions } = rootOptions;

  const app = createApp({
    ...restOptions,
    data() {
      const inherited =
        typeof ownData === "function"
          ? ownData.call(this) || {}
          : ownData || {};

      return {
        // Grupo "Peralba pro" emitido 1 vez por pagina en el layout
        // (partials/trans-peralba-pro-global); el blade lo pasa como prop.
        transPeralbaPro: window.transPeralbaPro || {},
        ...inherited,
        ...rootData,
      };
    },
  });

  app.component(iconsTag, XIcons);

  return app;
}

export default createPageApp;
